import { _DOCUMENT_, _HEAD_ } from "constants/dom";
import { EVENTS_PREFIX } from "core/config";
import createElement from "helpers/dom/createElement";

const insertCSSContents = (content: string) => {
  if (!content) {
    return;
  }
  const elem = createElement("style");
  elem.setAttribute("data-banner", `${EVENTS_PREFIX}_banner_styles`);
  elem.innerHTML = content;
  elem.id = "consent-custom-styles";

  // Get nonce meta information
  const nonceMeta =
    _HEAD_.querySelector('meta[property="csp-nonce"]') ||
    _HEAD_.querySelector('meta[name="csp-nonce"]');

  const nonce = nonceMeta && nonceMeta.getAttribute("content");
  if (nonce) {
    elem.nonce = nonce;
  }

  // append styles to body to fix async-loaded css files overriding them
  _DOCUMENT_.body.appendChild(elem);
};

export default insertCSSContents;
